module.exports = __webpack_public_path__ + "a727ac365d68d5e26346e0f0790fcaf7.png";